import * as React from 'react';

interface IUseParentTabs {
  tabValue: string;
  tabDestination?: string;
  handleOnTabChange: (value: string) => void;
  handleOnTabDestinationChange: (value?: string) => void;
}

export const useParentTabs = (
  initialTab: string,
  initialDestination?: string,
) => {
  const initValue = initialTab;
  const [tabValue, setTabValue] = React.useState<string>(initialTab);
  const [tabDestination, setTabDestination] = React.useState<
    string | undefined
  >(initialDestination);

  const handleOnTabChange = React.useCallback(
    (value: string) => {
      setTabValue(value);
    },
    [setTabValue],
  );

  const handleOnTabDestinationChange = React.useCallback(
    (value: string | undefined) => {
      setTabDestination(value);
    },
    [setTabDestination],
  );

  React.useEffect(() => {
    if (tabValue === initValue && tabDestination !== undefined) {
      handleOnTabDestinationChange(undefined);
    }
  }, [handleOnTabDestinationChange, initValue, tabDestination, tabValue]);

  return React.useMemo((): IUseParentTabs => {
    return {
      tabValue,
      tabDestination,
      handleOnTabDestinationChange,
      handleOnTabChange,
    };
  }, [
    handleOnTabDestinationChange,
    handleOnTabChange,
    tabDestination,
    tabValue,
  ]);
};
